import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ButtonComponent,
  HeaderComponent,
  SecondaryUtilityFlyoutItem,
  SecondaryUtilityFlyoutComponent,
} from '@zeiss/beyond-online-angular';
import { filter, map } from 'rxjs';
import { ROUTE_PATHS } from '../../../routing/routes.pojo';
import { AppState } from '../../services/app-state/app-state';
import { LanguageService } from '../../services/language/language.service';
import { Drawer } from '../drawer/drawer';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header',
  imports: [
    TranslocoDirective,
    ButtonComponent,
    RouterLink,
    Drawer,
    HeaderComponent,
    SecondaryUtilityFlyoutComponent,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'header',
  },
})
export class Header {
  public readonly routePaths = ROUTE_PATHS;
  private languageService = inject(LanguageService);
  public appState = inject(AppState);
  private router = inject(Router);

  public languageSwitchLabel = this.languageService.activeLangLabel;

  public secondaryUtilityItems = computed<SecondaryUtilityFlyoutItem[]>(() => {
    return this.languageService.getAvailableLanguageIds().map((languageId) => ({
      label: this.languageService.getDisplayLabel(languageId),
      value: languageId,
      checked: languageId === this.languageService.activeLang(),
    }));
  });

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => (event as NavigationEnd).urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  public navigateHome() {
    this.router.navigate([ROUTE_PATHS.home]);
  }

  public onLanguageSelected(item: SecondaryUtilityFlyoutItem) {
    this.languageService.setActiveLang(item.value);
  }

  public showNewConsultationButton = computed(() => {
    const url = this.currentUrl();
    return url !== ROUTE_PATHS._ && url !== ROUTE_PATHS.home;
  });
}
